import React from "react";
import { Box } from "@mui/material";
import flutter from "../../img/flutter.png";
import react from "../../img/react.png";

export default function Toggler({ darkMode, handleClick }) {
  return (
    <Box fontSize={"1.5rem"} paddingTop={2}>
      {darkMode ? (
        <Box
          onClick={handleClick}
          component={"img"}
          src={flutter}
          height={30}
          width={30}
        />
      ) : (
        <Box
          onClick={handleClick}
          component={"img"}
          src={react}
          height={30}
          width={30}
        />
      )}
    </Box>
  );
}
